import { Injectable, signal, WritableSignal } from '@angular/core';

import { DavinciSsoScenario } from '@ph-core/services/auth/auth-sso-attempt.model';
import { notificationDefaultDuration } from '@ph-static-data/notification-durations';

interface ErrorState {
  status: string;
  message: string;
  show: boolean;
  duration?: number;
  ssoScenario?: DavinciSsoScenario | null;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  error: WritableSignal<ErrorState> = signal({
    status: '',
    message: '',
    show: false,
    duration: notificationDefaultDuration,
    ssoScenario: null,
  });

  displayErrorMessage(status: number, text: string, duration: number = notificationDefaultDuration): void {
    this.error.set({
      status: (status && status.toString()) || '',
      message: text,
      show: true,
      duration,
      ssoScenario: null,
    });
  }

  displaySsoError(
    scenario: DavinciSsoScenario,
    message = '',
    duration: number = notificationDefaultDuration
  ): void {
    this.error.set({
      status: '401',
      message,
      show: true,
      duration,
      ssoScenario: scenario,
    });
  }

  hideErrorMessage(): void {
    this.error.set({ status: '', message: '', show: false, ssoScenario: null });
  }
}
